export default {
  index: "Manage Potential Customers",
  "customer-create": "Add New Customer",
  "customer-update": "Edit Customer",
  "job-update": "Edit Job",
  jobs: "Manage Jobs",
  "dispatch-sheet": "Dispatch Sheet",
  templates: "Manage Templates",
  "template-create": "Add Template",
  "template-update": "Edit Template",
  "car-make": "Car Make Model / Applications",
  "car-make-update": "Edit Car Make Model / Applications",
  "car-make-create": "Add New Car Make Model / Applications",
  "car-make-unlocking": "Car Make Model / Unlocking",
  "car-make-unlocking-update": "Edit Car Make Model / Unlocking",
  "car-make-unlocking-create": "Add New Car Make Model / Unlocking",
  "mechanical-key": "Mechanical Key",
  "insert-blade": "Insert Blade",
  technicians: "Manage Technicians",
  "technicians-update": "Edit Technician",
  "technicians-create": "Add Technician",
  fields: "Manage Fields",
  users: "Manage Dispatchers",
  "user-create": "Add User",
  "user-update": "Edit User",
  sms: "Customer SMS",
  smsView: "Customer SMS",
  "technician-sms": "Technician SMS",
  technicianSMSView: "Technician SMS",
  "zip-codes": "Zip Codes",
  cmp: "CMP",
  "search-engine": "Search Engine",
  "sms-templates": "SMS Template",
  "customer-emails": "Customer Emails",
  "key-logs": "Key Category & Type Logs",
};
